<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
html,body,#app{
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue